import script from "./Messages.vue?vue&type=script&lang=ts&setup=true"
export * from "./Messages.vue?vue&type=script&lang=ts&setup=true"

import "./Messages.vue?vue&type=style&index=0&id=20422452&lang=scss&scoped=true"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20422452"]])

export default __exports__